export const returnDefaultPhonenumberPrefix = (countryCode?: string) => {
  switch (countryCode) {
    case "dnk":
      return { value: "+45", label: "🇩🇰 +45" }
    case "isl":
      return { value: "+354", label: "🇮🇸 +354" }
    case "nor":
      return { value: "+47", label: "🇳🇴 +47" }
    case "grl":
      return { value: "+299", label: "🇬🇱 +299" }
    default:
      return { value: "+45", label: "🇩🇰 +45" }
  }
}
